<div class="message">
    <fa-icon *ngIf="icon" [icon]="icon" class="message__icon"></fa-icon>
    <div class="message__text">
        <ng-content></ng-content>
    </div>
</div>